import { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export function RequireAuth({ children }: PropsWithChildren<{}>) {
  const location = useLocation();
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;

  if (!token) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

